/** Render attachment ownership. Size changes replace only viewport attachments. */
export class RenderTargets {
  readonly shadow: GPUTexture
  readonly shadowView: GPUTextureView
  colorView!: GPUTextureView
  depthView!: GPUTextureView
  private color?: GPUTexture
  private depth?: GPUTexture
  private width = 0
  private height = 0

  constructor(private readonly device: GPUDevice, private readonly format: GPUTextureFormat) {
    this.shadow = device.createTexture({
      label: '2048 directional shadow map', size: [2048, 2048], format: 'depth32float',
      usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING,
    })
    this.shadowView = this.shadow.createView()
  }

  resize(width: number, height: number): void {
    if (width === this.width && height === this.height) return
    this.color?.destroy(); this.depth?.destroy()
    this.width = width; this.height = height
    this.color = this.device.createTexture({ label: '4× multisampled color', size: [width, height], sampleCount: 4, format: this.format, usage: GPUTextureUsage.RENDER_ATTACHMENT })
    this.depth = this.device.createTexture({ label: '4× multisampled depth', size: [width, height], sampleCount: 4, format: 'depth24plus', usage: GPUTextureUsage.RENDER_ATTACHMENT })
    this.colorView = this.color.createView()
    this.depthView = this.depth.createView()
  }

  dispose(): void { this.shadow.destroy(); this.color?.destroy(); this.depth?.destroy() }
}
